import template from "../html/dialog-config-dissolvedoxygen.html";
import css from "../css/dialog-config-dissolvedoxygen.css";
import Dialog from "dialog";
import sleep from "sleep";

class ConfigDissolvedOxygenDialog extends Dialog {
  static get template() {
    return template;
  }
  static get css() {
    return css;
  }
  static constructor() {
    customElements.define("fulljs-dialog-config-dissolvedoxygen", ConfigDissolvedOxygenDialog);
  }
  constructor() {
    super();

    document.addEventListener("onupdatedevices", this.onupdatedevices_handler.bind(this));

    this.onupdatedevices_handler({detail: application.devices});

    this.show();
  }
  onupdatedevices_handler(event) {
    var devices = event.detail;

    this.textboxDeviceID.value = devices.dissolvedOxygenSensor.id;
    this.textboxDeviceStatus.value = devices.dissolvedOxygenSensor.status;
    this.textboxValue.value = devices.dissolvedOxygenSensor.value;
    this.textboxCalibrationStatus.value = devices.dissolvedOxygenSensor.calibrationStatus;
    this.textboxInternalTemperature.value = devices.dissolvedOxygenSensor.internalTemperature;
    this.textboxTemperatureCompensationStatus.value = devices.dissolvedOxygenSensor.temperatureCompensationStatus;
  }
  async buttonClearCalibration_click() {
    try {
      this.buttonClearCalibration.style.pointerEvents = "none";  
      this.buttonClearCalibration.icon.iconname = "view-refresh";
      await server.rcall("RM_dissolvedOxygenSensor_clearCalibration");
      this.buttonClearCalibration.icon.iconname = "dialog-ok-apply";
    } catch(e) {
      this.buttonClearCalibration.icon.iconname = "process-stop";
    } finally {
      await sleep(3000);
      this.buttonClearCalibration.icon.iconname = "dialog-ok";
      this.buttonClearCalibration.style.pointerEvents = "";          
    }		
  }
  async buttonCalibrateTo0_click() {
    try {
      this.buttonCalibrateTo0.style.pointerEvents = "none";
      this.buttonCalibrateTo0.icon.iconname = "view-refresh";
      await server.rcall("RM_dissolvedOxygenSensor_calibrateTo0");
      this.buttonCalibrateTo0.icon.iconname = "dialog-ok-apply";
    } catch(e) {
      this.buttonCalibrateTo0.icon.iconname = "process-stop";
    } finally {
      await sleep(3000);
      this.buttonCalibrateTo0.icon.iconname = "dialog-ok";
      this.buttonCalibrateTo0.style.pointerEvents = "";
    }
  }
  async buttonCalibrateTo21_click() {
    try {
      this.buttonCalibrateTo21.style.pointerEvents = "none";
      this.buttonCalibrateTo21.icon.iconname = "view-refresh";
      await server.rcall("RM_dissolvedOxygenSensor_calibrateTo21");
      this.buttonCalibrateTo21.icon.iconname = "dialog-ok-apply";
    } catch(e) {
      this.buttonCalibrateTo21.icon.iconname = "process-stop";
    } finally {
      await sleep(3000);
      this.buttonCalibrateTo21.icon.iconname = "dialog-ok";
      this.buttonCalibrateTo21.style.pointerEvents = "";
    }
  }    
  buttonClose_click() {
    this.close();
  }
  close() {
    super.close();
  }
}

ConfigDissolvedOxygenDialog.constructor();

export default ConfigDissolvedOxygenDialog;